import React, { Component } from "react";
import Axios from "axios";
import { Link } from "react-router-dom";
import "../../css/style.css";

import Constant from "../Constant";
import $ from "jquery";
import { getAccessToken } from "../../hooks/AccessToken";

class AddUpdate extends Component {
  /*..................................... default state object ............................................*/

  state = {
    title: "",
    story_count: 0, // New field for story count
    poem_count: 0, // New field for poem count
    type: "", // 'writer' or 'reader'
    icon: null,
    status: 1,
    GetData: {},
    ERROR: true,
  };

  handleChange = (e) => {
    const key = e.target.name || e.target.id;
    this.setState({
      [key]: e.target.value,
    });
  };

  handleImage = (e) => {
    this.setState({
      [e.target.id]: e.target.files[0],
    });
  };

  /*.................. Integrate API for add, update data...............................................*/

  handleSubmit = async (event) => {
    try {
      let token = getAccessToken();
      event.preventDefault();
      let id = this.props.match.params.id;
      let form_data = new FormData();

      if (id === undefined) {
        if (this.state.icon === null) {
          $("#error-image-msg").text("File is required");
          $("#error-image-msg").css("color", "red");
          return false;
        }
        console.log(this.state.icon);

        let fileName = this.state.icon.name;
        let extension = fileName.split(".").pop();

        if (extension !== "jpg" && extension !== "png") {
          $("#error-image-msg").text("Only jpg and png file type are allow !");
          $("#error-image-msg").css("color", "red");
          return false;
        }

        form_data.append("title", this.state.title);
        form_data.append("story_count", this.state.story_count);
        form_data.append("poem_count", this.state.poem_count);
        form_data.append("badgeIcon", this.state.icon, this.state.icon.name);
        form_data.append("type", this.state.type);

        if (this.state.status !== undefined) {
          form_data.append("status", Number(this.state.status));
        }
        console.log(form_data);

        Axios.post(Constant.apiBasePath + "badge/create", form_data, {
          headers: { token: token },
        })
          .then((response) => {
            let data = response.data;
            if (data.status === Constant.statusSuccess) {
              $("#gen-message").text(data.message);
              $("#gen-message").css("color", "green");
              setTimeout(function () {
                window.location.href = "/badge-management";
              }, 3000);
            } else {
              $("#gen-message").text(data.message);
              $("#gen-message").css("color", "red");
            }
          })
          .catch((error) => {
            if (error.response === undefined) {
              $("#gen-message").text("API is not working");
              $("#gen-message").css("color", "red");
              return false;
            } else {
              $("#gen-message").text(error.response.data.message);
              $("#gen-message").css("color", "red");
              return false;
            }
          });
      } else {
        let { GetData } = this.state;
        const form_data = new FormData();

        // Append title
        this.state.title
          ? form_data.append("title", this.state.title)
          : form_data.append("title", GetData.title);

        // Append story_count
        this.state.story_count !== undefined
          ? form_data.append("story_count", this.state.story_count)
          : form_data.append("story_count", GetData.story_count || 0);

        // Append poem_count
        this.state.poem_count !== undefined
          ? form_data.append("poem_count", this.state.poem_count)
          : form_data.append("poem_count", GetData.poem_count || 0);

        // Append icon
        this.state.icon
          ? form_data.append("icon", this.state.icon, this.state.icon.name)
          : form_data.append("icon", GetData.icon);

        // Append type
        this.state.type
          ? form_data.append("type", this.state.type)
          : form_data.append("type", GetData.type);

        // Append status if available
        if (this.state.status !== undefined) {
          form_data.append("status", Number(this.state.status));
        } else {
          form_data.append("status", GetData.status);
        }

        console.log(form_data);
        Axios.patch(Constant.apiBasePath + "badge/edit/" + id, form_data, {
          headers: { token: token },
        })
          .then((response) => {
            let data = response.data;
            if (data.status === Constant.statusSuccess) {
              $("#gen-message").text(data.message);
              $("#gen-message").css("color", "green");
              setTimeout(function () {
                window.location.href = "/badge-management";
              }, 3000);
            }
          })
          .catch((error) => {
            if (error.response === undefined) {
              $("#gen-message").text("API is not working");
              $("#gen-message").css("color", "red");
              return false;
            } else {
              $("#gen-message").text(error.response.data.message);
              $("#gen-message").css("color", "red");
              return false;
            }
          });
      }
    } catch (err) {
      console.log(err);
    }
  };

  // get donation data by id

  async getGetData(id) {
    let token = getAccessToken();

    let req = {
      method: "GET",
      url: Constant.apiBasePath + "badge/getDataById/" + id,
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
        token: token,
      },
      json: true,
    };

    Axios(req)
      .then((response) => {
        const { data } = response;
        if (data.status === Constant.statusSuccess) {
          this.setState({ GetData: data.data[0], ERROR: false });
        } else {
          $("#gen-message").text(data.message);
          $("#gen-message").css("color", "red");
        }
      })
      .catch((error) => "Something Error");
  }

  /*---------------------------Reload function------------------------------------------ */

  componentDidMount() {
    // get data by id
    if (this.props.match.params.id) {
      this.getGetData(this.props.match.params.id);
    }
  }

  /*.................................end API .................................................................*/

  render() {
    const { GetData } = this.state;
    let title = "";
    let story_count = 0;
    let poem_count = 0;
    let icon = "";
    let type = "";

    let btnVal = "Add";
    let heading = "Add Badge";
    let types = (
      <>
        <option id="0" value="">
          Select one
        </option>
        <option id="writer" value="writer">
          Writer
        </option>
        <option id="reader" value="reader">
          Reader
        </option>
      </>
    );
    if (GetData.title !== undefined) {
      title = GetData.title;
      story_count = GetData.story_count || 0;
      poem_count = GetData.poem_count || 0;
      icon = GetData.icon;
      type = GetData.type;

      btnVal = "Update";
      heading = "Update Badge";
      if (type === "writer") {
        types = (
          <>
            <option id="0" value="">
              Select one
            </option>
            <option id="writer" value="writer" selected>
              Writer
            </option>
            <option id="reader" value="reader">
              Reader
            </option>
          </>
        );
      } else {
        types = (
          <>
            <option id="0" value="">
              Select one
            </option>
            <option id="writer" value="writer">
              Writer
            </option>
            <option id="reader" value="reader" selected>
              Reader
            </option>
          </>
        );
      }
    }

    return (
      <div className="content-page">
        <div className="content">
          <div className="row">
            <div className="col-12">
              <div className="page-title-box">
                <div className="page-title-right">
                  <ol className="breadcrumb m-0">
                    <li className="breadcrumb-item">
                      <Link to="/badge-management">Badge Management</Link>
                    </li>
                    <li className="breadcrumb-item active">Add New Badge</li>
                  </ol>
                </div>
                <h4 className="page-title-heading">{heading}</h4>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-12">
              <div className="card">
                <div className="card-body">
                  <form onSubmit={this.handleSubmit}>
                    <p id="gen-message"></p>
                    <div className="row">
                      <div className="col-md-6">
                        <div className="form-group mb-3">
                          <label htmlFor="type" className="state">
                            Writer/Reader *
                          </label>
                          <select
                            id="type"
                            className="form-control"
                            value={this.state.type}
                            onChange={this.handleChange}
                          >
                            {types}
                          </select>
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div className="form-group mb-3">
                          <label htmlFor="title" className="state">
                            Title *
                          </label>
                          <input
                            type="text"
                            id="title"
                            className="form-control"
                            value={this.state.title}
                            onChange={this.handleChange}
                          />
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div className="form-group mb-3">
                          <label htmlFor="story_count" className="state">
                            Story Count *
                          </label>
                          <input
                            type="number"
                            id="story_count"
                            className="form-control"
                            value={this.state.story_count}
                            onChange={this.handleChange}
                            min="0"
                          />
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div className="form-group mb-3">
                          <label htmlFor="poem_count" className="state">
                            Poem Count *
                          </label>
                          <input
                            type="number"
                            id="poem_count"
                            className="form-control"
                            value={this.state.poem_count}
                            onChange={this.handleChange}
                            min="0"
                          />
                        </div>
                      </div>
                      {icon ? (
                        <>
                          <div className="col-md-5">
                            <div className="form-group mb-3">
                              <label htmlFor="icon" className="state">
                                Upload Icon *
                              </label>
                              <input
                                type="file"
                                id="icon"
                                className="form-control"
                                onChange={this.handleImage}
                              />
                              <p id="error-icon-msg" />
                            </div>
                          </div>
                          <div className="col-md-1">
                            <div className="form-group mb-3">
                              <label htmlFor="state" className="state">
                                Icon
                              </label>
                              <img
                                src={icon}
                                className="form-control"
                                alt="StoryTent"
                                style={{ width: 50, height: 50 }}
                              />
                            </div>
                          </div>
                        </>
                      ) : (
                        <div className="col-md-6">
                          <div className="form-group mb-3">
                            <label htmlFor="icon" className="state">
                              Upload Icon *
                            </label>
                            <input
                              type="file"
                              id="icon"
                              className="form-control"
                              onChange={this.handleImage}
                            />
                            <p id="error-icon-msg" />
                          </div>
                        </div>
                      )}
                      <div className="col-md-6">
                        <div className="mb-3">
                          <label htmlFor="badge_status" className="state">
                            Status
                          </label>
                          <select
                            id="badge_status"
                            name="status"
                            className="form-control"
                            style={{ display: "block" }}
                            value={String(this.state.status)}
                            onChange={this.handleChange}
                          >
                            <option value="1">Active</option>
                            <option value="0">Inactive</option>
                          </select>
                        </div>
                      </div>
                    </div>
                    <button type="submit" className="btn btn-info">
                      {btnVal}
                    </button>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
export default AddUpdate;
